import React from 'react';
import TutorEffectiveAvailabilityView from './TutorEffectiveAvailabilityView';

/**
 * TutorAvailabilityCardView - Shows effective tutor availability with scheduled tasks filtered out.
 * This is a wrapper around TutorEffectiveAvailabilityView for backwards compatibility.
 * 
 * Used by: Parent Dashboard, Student Dashboard, Admin Dashboard
 */
const TutorAvailabilityCardView = ({ tutorId }) => {
  return (
    <TutorEffectiveAvailabilityView 
      tutorId={tutorId} 
      title="Available Slots"
    />
  );
};

export default TutorAvailabilityCardView;
